import { routes } from 'commons/routes-paths';
import { ReactComponent as AlertSign } from 'static/images/alert-sign.svg';
import { ReactComponent as Clock } from 'static/images/clock.svg';
import { ReactComponent as MagnifyingGlass } from 'static/images/magnifying-glass.svg';
import { ReactComponent as PersonBuying } from 'static/images/person-buying.svg';
import { ReactComponent as TruckToLeft } from 'static/images/truck-to-left.svg';
import { ReactComponent as TruckToRight } from 'static/images/truck-to-right.svg';
import {
  CardInfoDisplay,
  DashboardCardType,
  HomeFilterParam,
  QueryParam,
  ReturnFilterParam,
} from 'types';

const { exchangeAndReturn } = routes;
const { filter } = QueryParam;
const {
  servicePending,
  waitingForCustomer,
  deliveryFail,
  pickupByDriver,
  verifyConsignment,
} = HomeFilterParam;
const { returnsInProgress } = ReturnFilterParam;

export const CARD_INFO_DISPLAY_MAP: Record<DashboardCardType, CardInfoDisplay> =
  {
    WAITING_ATTENDANCE: {
      title: 'Atendimento pendente',
      buttonLabel: 'Ver pedidos',
      bgIcon: <Clock />,
      navigatePath: `?${filter}=${servicePending}`,
      tooltipMessage:
        'Há pedidos com o tempo de atendimento próximo de expirar',
    },
    RETURN_REQUEST_IN_PROGRESS: {
      title: 'Devoluções em andamento',
      buttonLabel: 'Ver devoluções',
      bgIcon: <TruckToLeft />,
      navigatePath: `${exchangeAndReturn.path}?${filter}=${returnsInProgress}`,
      tooltipMessage: 'Há devoluções a um tempo sem tratativa',
    },
    WAITING_CUSTOMER_PICK_UP: {
      title: 'Aguardando cliente retirar',
      buttonLabel: 'Ver pedidos',
      bgIcon: <PersonBuying />,
      navigatePath: `?${filter}=${waitingForCustomer}`,
      tooltipMessage: 'Há pedidos aguardando o cliente há bastante tempo',
    },
    DELIVERY_FAILURE: {
      title: 'Falha na entrega/coleta',
      buttonLabel: 'Ver falhas',
      bgIcon: <AlertSign />,
      navigatePath: `?${filter}=${deliveryFail}`,
    },
    ON_CARRIAGE: {
      title: 'Em transporte',
      buttonLabel: 'Ver pedidos',
      bgIcon: <TruckToRight />,
      navigatePath: `?${filter}=${pickupByDriver}`,
    },
    DELIVERY_FAILED_QUESTION: {
      title: 'Pedidos a verificar',
      buttonLabel: 'Verificar pedidos',
      bgIcon: <MagnifyingGlass />,
      navigatePath: `?${filter}=${verifyConsignment}`,
    },
  };

export const DASHBOARD_SUMMARY_DAYS_DIFFERENCE = 90;
